import { createVanIconComponent } from "./van"

const GoodJobOutlined = createVanIconComponent("good-job-o")
export default GoodJobOutlined
